@let isEditUser = isEditUser$ | async;
<ui-headline-wrapper>
    @if (isEditUser) {
        <ui-headline [title]="'modules.programs.head' | translate" [headlineButtonContext]="headlineButtonContext" [content]="content" />
    } @else {
        <ui-headline [title]="'modules.programs.head' | translate" />
    }
</ui-headline-wrapper>

<ui-content-wrapper [colAdditionalClass]="'px-0'" [classPx]="'px-3'">
    <b2b-table-b2b-programs
        [readonly]="!isEditUser"
        [pending]="pending$ | async"
        [b2bProgram]="b2bPrograms$ | async"
        (clickRow)="handlerClickRow($event)"
        (removeClick)="handlerDeleteProgram($event)" />
</ui-content-wrapper>
